import type { ImAccount } from '@fruitful/types';
import { SupportedApexAccountRegistrationType } from '@fruitful/types';

const BACKDOOR_TRAD_REGISTRATION_TYPES: ReadonlySet<SupportedApexAccountRegistrationType> =
    new Set([
        SupportedApexAccountRegistrationType.RegistrationIraTraditional,
        SupportedApexAccountRegistrationType.RegistrationIraRollover,
    ]);

/** Traditional (or rollover) IRA leg with auto-conversion enabled — show ICT conversion notice. */
export const isBackdoorTraditionalIraContributionContext = (
    account: ImAccount | null | undefined,
): boolean =>
    account?.backdoorRothRole === 'TRADITIONAL' &&
    account.autoConvert === true &&
    account.registrationType != null &&
    BACKDOOR_TRAD_REGISTRATION_TYPES.has(account.registrationType);

export const findPairedRothAccountForBackdoorTrad = (
    fundedAccount: ImAccount | null | undefined,
    apexAccounts: ImAccount[] | undefined,
): ImAccount | undefined => {
    const pairedId = fundedAccount?.backdoorRothPairedApexAccountId;
    if (
        pairedId == null ||
        pairedId === '' ||
        apexAccounts == null ||
        apexAccounts.length === 0
    ) {
        return undefined;
    }
    return apexAccounts.find((a) => a.apexAccountId === pairedId);
};
